import React, { type FC, type ReactElement } from 'react';
import type { Hotel } from '../../../interfaces';

export type OfferAmenity = Pick<Hotel, 'facilities' | 'activities'>;

export const Amenity: FC<OfferAmenity> = ({ facilities, activities }): ReactElement<OfferAmenity> => {
    const renderAllAmenities = (): string[] => {
        const amenitiesCollection: string[] = [];
        return amenitiesCollection
            .concat(facilities, activities)
            .filter(Boolean)
            .map((amenity, index): string => (index ? ` • ${amenity}` : amenity));
    };

    return (
        <div className="u-mb16 u-stone u-r-size1of2" data-testid="offerAmenities">
            {renderAllAmenities()}
        </div>
    );
};
